import styled from "styled-components"
import {
  width,
  WidthProps,
  space,
  SpaceProps,
  borderColor,
  borderWidth,
  BorderWidthProps,
  BorderColorProps
} from "styled-system"

export const Separator = styled.hr<WidthProps & SpaceProps & BorderColorProps & BorderWidthProps>`
  border: 1px solid;

  ${width}
  ${space}
  ${borderColor}
  ${borderWidth}
`

Separator.defaultProps = {
  borderColor: "lightGrey",
  width: "auto"
}
